import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRollingLoadingIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	width: 200,
	height: 200,
	style: {
		shapeRendering: "auto",
		display: "block",
		background: "transparent"
	},
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
		strokeDasharray: "197.92033717615698 67.97344572538566",
		r: 42,
		strokeWidth: 8,
		stroke: "#bca4ff",
		fill: "none",
		cy: 50,
		cx: 50,
		children: /* @__PURE__ */ _jsx("animateTransform", {
			keyTimes: "0;1",
			values: "0 50 50;360 50 50",
			dur: "1s",
			repeatCount: "indefinite",
			type: "rotate",
			attributeName: "transform"
		})
	}), /* @__PURE__ */ _jsx("g", {})] })
});
export default SvgRollingLoadingIcon;
